import './Licensed.css';

export default function Licensed() {
  return (
    <section className="licensed" aria-labelledby="licensed-heading">
      <div className="licensed-inner">
        <div className="licensed-visual">
          <img
            src="/images/licensed-collector-arrival.png"
            alt="SnapScrap collector arriving at a property with a washing machine, radiator, bike and other metal items ready for collection"
            loading="lazy"
          />
        </div>

        <div className="licensed-content">
          <h2 id="licensed-heading">Fully Licensed Local Collectors</h2>
          <p>
            Your scrap is collected by verified, licensed scrap collectors in your area.
          </p>
          <p>
            Post your unwanted metal items for free and SnapScrap connects you with an available
            local collector. Simple, responsible and convenient.
          </p>
        </div>
      </div>
    </section>
  );
}
